<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="0"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-layout>
      <v-flex>
        <v-row align="center">
          <!-- Left-aligned button -->
          <v-col cols="3" class="text-left">
            <v-btn color="primary"  @click="goToStockHome">Back</v-btn>
          </v-col>

          <!-- Center-aligned text -->
          

          <!-- Spacer to fill the right side -->
          <v-col cols="3"></v-col>
        </v-row>
        <v-card>
          <v-tabs
            v-model="selectedTab"
            class="no-border-tabs"
          >

            <v-tab value="1" key="stockDetailStatusTracker">Stock Details Status Tracker</v-tab>
            <v-tab value="2" key="stockStatusGrade">Stock Status Grade</v-tab>
            <v-tab value="3" key="stockStatusSummery">Stock Status Summery</v-tab>

          </v-tabs>

          <v-tabs-items v-model="selectedTab">
            <v-tab-item key="stockDetailStatusTracker">
              <stockDetailStatusTracker/>
            </v-tab-item>
            <v-tab-item key="stockStatusGrade">
              <stockStatusGrade/>
            </v-tab-item>
            <v-tab-item key="stockStatusSummery">
              <stockStatusSummery/>
            </v-tab-item>

          </v-tabs-items>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import stockDetailStatusTracker from '@/components/views/grower/stockDetailStatusTracker.vue'
import stockStatusGrade from '@/components/views/grower/stockStatusGrade.vue'
import stockStatusSummery from '@/components/views/grower/stockStatusSummery.vue'

export default {
	name: 'growerstockdetails',
	components: {
		stockDetailStatusTracker,
		stockStatusGrade,
		stockStatusSummery
	},

	data: function () {
		return {
			selectedTab: null,
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: ''

		}
	}

}

</script>
<style scoped>
</style>
